import React from 'react';

type Props = {
  icon: React.ReactNode;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  className?: string;
};

/** Единое "красивое" пустое состояние — иконка + заголовок + подпись, карточка с тенью. */
export function EmptyState({ icon, title, subtitle, className = '' }: Props) {
  return (
    <div className={`fc-empty-state${className ? ` ${className}` : ''}`}>
      <span className="fc-empty-state__icon" aria-hidden>
        {icon}
      </span>
      <b className="fc-empty-state__title">{title}</b>
      {subtitle ? <p className="fc-empty-state__subtitle">{subtitle}</p> : null}
    </div>
  );
}
